import React from 'react'

import styles from './DealInfo.module.scss'

export const DealGuidelines = () => {
  return (
    <div className={styles.textBlock}>
      <div>Guidelines to note:</div>
      <div>1. Only for T2 Non-Managed Final Tier Partners (Unattended only) pan BU.</div>
      <div>2. The threshold of minimum deal size is US$20K.</div>
      <div>3. L{`&`}R screening is needed for every Partner.</div>
      <div>
        4. Requester is accountable to ensure the undertaking letter is used for one-time Special
        Pricing deal only.
      </div>
      <div>
        5. Partner must submit deal request to HP within 30 days from the signature date of the
        letter of undertaking.
      </div>
    </div>
  )
}
